module.exports = __webpack_public_path__ + "img/ic_paypal_payment-method-light.389e3cd.svg";